import { MoreVertical } from "lucide-react";
import { useState } from "react";

export const ActionDropdown = ({ rowData, actions, actionDropClicked }) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const isOpen = openDropdown === rowData?.id || openDropdown === rowData?._id;
  const handleDropdownToggle = (orgId) => {
    setOpenDropdown(openDropdown === orgId ? null : orgId);
  };
  const handleActionClick = (action, rowData) => {
    console.log(`${action} clicked for rowData ${rowData}`);
    setOpenDropdown(null);
    const tempObject = { action, rowData };
    actionDropClicked(tempObject);
  };

  return (
    <div className="dropdown position-relative">
      <button
        className="action-dropdown-toggle"
        onClick={() => handleDropdownToggle(rowData?.id || rowData?._id)}
        aria-expanded={isOpen}
      >
        <MoreVertical size={16} />
      </button>

      {isOpen && (
        <>
          <div
            className="position-fixed top-0 start-0 w-100 h-100"
            style={{ zIndex: 1040 }}
            onClick={() => setOpenDropdown(null)}
          />
          <div
            className="dropdown-menu action-dropdown-menu show position-absolute"
            style={{ zIndex: 1050, right: 0, top: "100%" }}
          >
            {actions.map((action) => {
              const Icon = action.icon;
              return (
                <button
                  key={action.id}
                  className="action-dropdown-item"
                  onClick={() =>
                    handleActionClick(action.value, rowData)
                  }
                >
                  <Icon size={16} />
                  {action.label}
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};
